import { useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Contract } from 'ethers'
import { useSWRContract, UseSWRContractKey } from 'hooks/useSWRContract'
import { JsonRpcProvider } from '@ethersproject/providers'
import { getMjtAddress } from 'utils/addressHelpers'
import mjtABI from 'constants/abis/mjt.json'

// TODO: refactor as useTokenApprovalStatus for generic use
const useMjtApprovalStatus = (spender) => {
  const { account, library } = useWeb3React()
  const signer = library?.getSigner()
  const provider = signer ?? new JsonRpcProvider(process.env.REACT_APP_NETWORK_URL).getSigner()
  const mjtContract = useMemo(() => {
    return new Contract(getMjtAddress(), mjtABI, provider)
  }, [provider])

  const key = useMemo<UseSWRContractKey>(
    () =>
      account && spender
        ? {
            contract: mjtContract,
            methodName: 'allowance',
            params: [account, spender],
          }
        : null,
    [account, mjtContract, spender]
  )

  const { data, mutate } = useSWRContract(key)

  return { isVaultApproved: data ? data.gt(0) : false, setLastUpdated: mutate }
}

export default useMjtApprovalStatus
